if (!customElements.get('ugc-media')) {
  class UgcMedia extends HTMLElement {
    constructor() {
      super();
      this.initSliderHandler = this.querySelector('.js-init-slider');
      this.swiperInstance = null;
    }

    initSlider() {
      this.swiperInstance = new Swiper(this.initSliderHandler, {
        loop: true,
        speed: +this.dataset.autoplaySpeed * 1000,
        loopAdditionalSlides: 3,
        autoplay: this.dataset.autoplay === 'true' ? {
          delay: 1,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        } : false,
        freeMode: {
          enabled: true,
          sticky: false,
          momentum: true,
        },
        slidesPerView: 'auto',
        spaceBetween: 0,
        grabCursor: true,
        allowTouchMove: true,
        cssMode: false,
        loopedSlides: 6,
        centeredSlides: true,
        breakpoints: {
          768: {
            centeredSlides: true,
          }
        }
      });
    }

    connectedCallback() {
      setTimeout(() => {
        this.initSlider();
      }, 0);
    }

    disconnectedCallback() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
      }
    }
  }

  customElements.define('ugc-media', UgcMedia);
}
